/**
 * Единые классы для экранов HR в PWA (поля, кнопки, чипы фильтров).
 * Primary-стили стыкуются с `ui-tokens` (те же hover/focus/disabled).
 */

import { cn } from '@/lib/utils';
import {
  pwaFieldClass,
  pwaPrimaryButtonDisabledClass,
  pwaPrimaryButtonFocusClass,
  pwaPrimarySelectedClass,
  pwaPrimarySolidClass,
} from '@/lib/ui-tokens';

/** HR forms — та же filled-семья, что `PwaTextField`. */
export const hrFieldClass = pwaFieldClass;

export const hrLabelClass = 'block text-xs font-semibold uppercase tracking-wide text-[var(--muted-foreground)] dark:text-[var(--muted-foreground)]';

export const hrPrimaryButtonClass = cn(
  'inline-flex w-full items-center justify-center rounded-full px-4 py-3 text-sm font-semibold',
  pwaPrimarySolidClass,
  pwaPrimaryButtonDisabledClass,
  pwaPrimaryButtonFocusClass
);

export const hrSecondaryButtonClass =
  'inline-flex w-full items-center justify-center rounded-full border border-[var(--border)] bg-[var(--surface)] px-4 py-3 text-sm font-medium text-[var(--foreground)] transition hover:bg-[var(--surface-soft)] disabled:opacity-50 dark:border-[var(--border)] dark:bg-[var(--surface)]';

export const hrDatePairGridClass = 'grid min-w-0 grid-cols-1 gap-3 sm:grid-cols-2';

export const hrDatePairCellClass = 'min-w-0';

export function hrFilterChipClass(active: boolean): string {
  return cn(
    'whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium',
    active
      ? pwaPrimarySelectedClass
      : 'bg-[var(--surface-strong)] text-[var(--muted-foreground)] dark:bg-[var(--surface)] dark:text-[var(--muted-foreground)]'
  );
}
